
export default function TitleWhoComing(){
    return <div className="font-size22 color222 font-bold text-left mb-0">
    Who's coming?
  </div>
}